import * as React from 'react';
import Button from '@mui/material/Button';
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined';

export default function CompareButton({ onCompare }) {
    return (
        <>
            <Button
                startIcon={<GppGoodOutlinedIcon />}
                onClick={onCompare}
                variant='contained'
                size='large'
                sx={{
                    color: 'rgba(0, 0, 0, 0.87)',
                    backgroundColor: 'rgb(255, 193, 7)',
                    fontWeight: 'bold',
                    boxShadow:
                        '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)',
                    '&:active, &:hover': {
                        backgroundColor: 'rgb(178, 135, 4)',
                        boxShadow:
                            '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
                    },
                }}
            >
                Check now
            </Button>
        </>
    );
}
